import React, { Component } from "react";
import css from "./style.css";
import CSSModule from "react-css-modules";
import DropList from "../dropList";

const Bill = (props) => {
  const data = props.data;
  if (!data.charge_point) data.charge_point = data.cost_point - 1;
  if (!data.charge_per_price) data.charge_per_price = 250;
  //console.log(data);

  const listContent = Array.from(Array(10)).map((obj, index) => {
    return {
      label: index + 1,
    };
  });

  const renderSelecter = (point) => {
    if (!props.isRetail) return point;
    else {
      return (
        <DropList
          styleName="list"
          listContent={listContent}
          onSelected={props.onSelected}
          defaultIndex={1}
          width={130}
        />
      );
    }
  };
  return (
    <table styleName="rwd-table">
      <tbody>
        <tr>
          <th>品名</th>
          <th>項目</th>
          <th>單價</th>
          <th>數量</th>
          <th>小計</th>
        </tr>
        <tr>
          <td data-th="品名">{data.name}</td>
          <td data-th="項目">{data.item_name || "服務點數(無使用期限)"}</td>
          <td data-th="單價">{data.charge_per_price}</td>
          <td data-th="數量">{renderSelecter(data.charge_point)}</td>
          <td data-th="小計">{data.charge_per_price * data.charge_point}</td>
        </tr>
        {data.hasOwnProperty("premiums_point") && (
          <tr>
            <td data-th="品名"></td>
            <td data-th="項目">贈品點數(無使用期限)</td>
            <td data-th="單價">0</td>
            <td data-th="數量">{data.premiums_point}</td>
            <td data-th="小計">0</td>
          </tr>
        )}
        <tr>
          <td data-th="品名">總計</td>
          <td data-th="項目"></td>
          <td data-th="單價"></td>
          <td data-th="數量">
            {(data.premiums_point || 0) + data.charge_point}
          </td>
          <td data-th="小計">
            {data.charge_per_price * data.charge_point + 0}
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default CSSModule(Bill, css);



/** WEBPACK FOOTER **
 ** ./src/component/bill/index.js
 **/